gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis()

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0);

$(window).on("load", function () {
  // header menu
  $('.js-menu-ttl span').lettering();

  setTimeout(function () {
    const target = document.querySelectorAll(".js-io");
    const targetArray = Array.prototype.slice.call(target);
    const options = {
      root: null,
      rootMargin: "0% 0% -10% 0%",
      threshold: 0,
    };
    const observer = new IntersectionObserver(callback, options);
    targetArray.forEach((tgt) => {
      observer.observe(tgt);
    });

    function callback(entries) {
      entries.forEach(function (entry, i) {
        const target = entry.target;

        if (entry.isIntersecting && !target.classList.contains("_show")) {
          const delay = i * 100;
          setTimeout(function () {
            target.classList.add("_show");
          }, delay);
        }
      });
    }
  }, 400);
});

$(document).ready(function() {
  // loading
  const body = $("body");

  // if (body.hasClass("front-page")) {
  //   $("body").addClass("is-loading");
  //   $('.loading-txt-progress svg path').addClass('logo-loading');

  //   var imgLoad = imagesLoaded("body");
  //   var loadingNum = $('.loading-txt-num span')
  //     images = $("img").length,
  //     loadedCount = 0,
  //     loadingProgress = 0,
  //     tlProgress = gsap.timeline();
    
  //   imgLoad.on("progress", function (instance, image) {
  //     loadProgress();
  //   });
    
  //   function loadProgress() {
  //    loadedCount++;
  //    loadingProgress = loadedCount / images;
    
  //    gsap.to(tlProgress, { progress: loadingProgress, duration: 1 });
  //   }
    
  //   var tlProgress = gsap.timeline({
  //    paused: true,
  //    onUpdate: countPercent,
  //    onComplete: loadComplete,
  //   });

  //   tlProgress.to(loadingNum, { width: "100%", duration: 1 });

  //   function countPercent() {
  //     var newPercent = (tlProgress.progress() * 100).toFixed();
  //     loadingNum.text(newPercent);
  //   }
    
  //   function loadComplete() {
  //     setTimeout(() => {
  //       $('.loading-txt-num').addClass('loaded');
  //       $('.aj-txt').addClass('loaded');
  //       $('.loading-end').addClass('ended');
  //       setTimeout(() => {
  //         $(".loading").addClass('hidden');
  //         $('body').removeClass('is-loading');
  //         $('.mode-item-navi').addClass('loading-end');
  //         setTimeout(() => {
  //           $('.header').addClass('loaded');
  //           $('.fv-logo img').addClass('_show');
  //           $('.mode-setting-ttl ._cus-fadeup').addClass('_show');
  //           setTimeout(() => {
  //             $('.mode-setting-main .pick-up ._cus-fadeup').addClass('_show');
  //             setTimeout(() => {
  //               $('.mode-setting-main .division ._cus-fadeup').addClass('_show');
  //             }, 100);
  //           }, 100);
  //           setTimeout(() => {
  //             $('.mode-item-txt .mode-item-ttl').addClass('_show');
  //             setTimeout(() => {
  //               $('.mode-item-txt .mode-item-detail-date p').addClass('_show');
  //               setTimeout(() => {
  //                 $('.mode-item-txt .mode-item-detail-other p').addClass('_show');
  //                 setTimeout(() => {
  //                   $('.mode-item-share a').addClass('_show');
  //                   setTimeout(() => {
  //                     $('.mode-item-btn .more-btn').addClass('_show');
  //                     $('.mode-bg-img').addClass('loading-end');
  //                     $('.mode-item-img img').addClass('loading-end');
  //                     $('.mode-numbers ._cus-blur').addClass('_show');
  //                     setTimeout(() => {
  //                       $('.fv-slider__bg').removeClass('loading');
  //                     }, 100);
  //                   }, 50);
  //                 }, 50);
  //               }, 50);
  //             }, 50);
  //           }, 1000);
  //         }, 500);
  //       }, 1500);
  //     }, 500);
  //   }
  // } else {
  //   $('body').addClass('loaded');
  //   $('main').addClass('loaded');
  //   $('header').addClass('loaded');
  // }
});

let mm = gsap.matchMedia();

var fv_swiper = new Swiper(".fv-swiper", {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  autoplay: true,
  loop: true
});

var feature_swiper = new Swiper(".feature-swiper", {
  slidesPerView: 'auto',
  spaceBetween: 25,
  speed: 1200,
  autoplay: true,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});